import { Feature } from '@/pinia/feature'
import { usage } from './usage'
import { buildingScore } from './buildingScore'
import { indoorClimate } from './indoor-climate'
import { portfolioAnalysis } from './portfolio'
import { energyAnalysis } from './energy'
import { visitorAnalysis } from './visit-statistics'
import { indoorClimate2 } from './indoorClimate'
import { actualEnergy } from './actualEnergy'
import { newEnergyAnalysis } from './new-energy'
import { utilization } from './utilization'
import { utilizationRate } from './utilization-rate'
import { rentalObjectsAnalysis } from './rental-objects-analysis'

export const analytics: Feature = {
  name: 'analytics',
  enabled: true,
  access: [
    'FEAT_UTILIZATION_READER',
    'FEAT_BUILDING-SCORE_READER',
    'FEAT_INDOOR-CLIMATE_READER',
    'FEAT_PORTFOLIO-ANALYSIS_READER',
    'FEAT_ENERGY-ANALYSIS_READER',
    'FEAT_UTILIZATION-RATE_READER',
    'FEAT_RENTAL-OBJECT-ANALYSIS_READER'
  ],
  title: {
    en: 'Analysis & asset performance',
    sv: 'Analys & prestanda'
  },
  component: 'FeatureCard',
  isRoute: true,
  props: {
    icon: 'IconTimeLine',
    disableIsDrawPointActive: true
  },
  children: [
    {
      name: 'portfolio',
      enabled: true,
      title: {
        en: 'Portfolio',
        sv: 'Portfölj'
      },
      component: 'FeatureCard',
      props: {
        icon: 'IconTimeLine',
        disableIsDrawPointActive: true
      },
      children: [portfolioAnalysis, buildingScore]
    },
    {
      name: 'analyticareas',
      enabled: true,
      title: {
        en: 'Analytics areas',
        sv: 'Analysområden'
      },
      component: 'FeatureCard',
      props: {
        icon: 'IconTimeLine',
        disableIsDrawPointActive: true
      },
      children: [
        usage,
        visitorAnalysis,
        utilizationRate,
        indoorClimate,
        indoorClimate2,
        energyAnalysis,
        actualEnergy,
        newEnergyAnalysis,
        utilization,
        rentalObjectsAnalysis
      ]
    }
  ]
}
